module.exports = __webpack_public_path__ + "img/borderCubeWhite.a3a5d0ad.svg";